import styled from "styled-components";

export const Container = styled.div`
  position: relative;
`;

export const Badge = styled.div`
  background-color: red;
  position: absolute;
  height: 20px;
  min-width: 20px;
  padding: 3px;
  font-size: 10px;
  top: -10px;
  left: 12px;
  color: #fff;
  border: 1px solid #fff;
  border-radius: 4px;
  text-align: center;
`;
